module.exports = __webpack_public_path__ + "static/media/wide.f14bb2ea.jpg";